import { z } from 'zod';
import { BooleanOptional } from './schemaTypes';

export const CheckinSchema = z.object({
	CheckinConditions: z
		.array(z.string())
		.optional()
		.describe('Задает тексты условий на начальном шаге онлайн-регистрации'),
	showConsents: BooleanOptional.describe(
		'Условие для отображения чекбокса согласия на чекине (пока что только для услуг страхования)'
	),
	checkinRestrictionsEnabled: BooleanOptional
});
